import { RootState } from 'models';

const getUsers = (state: RootState) => state.configurator.users.users;

const getSelectedUser = (state: RootState) => state.configurator.users.selectedUser;

const getFormMode = (state: RootState) => state.configurator.users.formMode;

const getImportUserKey = (state: RootState) => state.configurator.users.importUserKey;

const getUserRoles = (state: RootState) => state.configurator.users.userRoles;

export default {
  getUsers,
  getSelectedUser,
  getFormMode,
  getImportUserKey,
  getUserRoles,
};
